/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import { formatTime, parseLocalDate } from 'time_formatting';
import { ReservationTimer } from './reservation_timer.jsx';
import { FormInputGroup } from '../../../react/form_input_group.jsx';
import { FormRow } from '../../../react/form_row.jsx';
import { TicketClassQuantityRow } from './ticket_class_quantity_row.jsx';
import _ from 'underscore';
import React from 'react';
import immutable from 'object-path-immutable';
import PropTypes from 'prop-types';
import { PromoCodeForm } from './promo_code_form.jsx';

function ticketClassDonationById(ticketClassGroups) {
  const map = {};
  for (const entry of ticketClassGroups || []) {
    for (const tc of entry[1] || []) {
      map[tc.id] = !!tc.donation;
    }
  }
  return map;
}

export class QuantityChooser extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onApplyPromoCode: PropTypes.func,
    onRemovePromoCode: PropTypes.func,
    onCancel: PropTypes.func
  };

        constructor(props) {
          let ticket_class_id;
          super(props);
          this.onSubmitForm = this.onSubmitForm.bind(this);
          this.onCancel = this.onCancel.bind(this);
          this.getFormData = this.getFormData.bind(this);
          this.isValid = this.isValid.bind(this);
          this.renderPromoCodeForm = this.renderPromoCodeForm.bind(this);
          this.onInstanceChange = this.onInstanceChange.bind(this);
          this.renderInstanceSelector = this.renderInstanceSelector.bind(this);
          this.onQuantityChange = this.onQuantityChange.bind(this);
          this.onItemPriceChange = this.onItemPriceChange.bind(this);
this.renderTicketGroups = this.renderTicketGroups.bind(this);

          // Prefill selectedQuantities with what the server says was selected for the selected instance
          const selectedDate = this.props.selected_instance_id ?? this.props.instances[0]?.id;
          const selectedQuantities = {};
          const donationAmounts = {};

          for (const ticket_class_id in this.props.ticket_availability?.[selectedDate]?.selected_quantities) {
            const quantity = this.props.ticket_availability?.[selectedDate]?.selected_quantities[ticket_class_id];
            selectedQuantities[ticket_class_id] = quantity;
          }

          // Restore donation amounts from cart (donation ticket classes only)
          const donationByTicketClassId = ticketClassDonationById(props.ticket_class_groups);
          for (const item of props.cart?.items ?? []) {
            if (donationByTicketClassId[item.ticket_class_id]) {
              donationAmounts[item.ticket_class_id] = item.price;
            }
          }

          this.state = {
            haveInstances: this.props.instances.length > 0,
            selectedDate,
            selectedQuantities,
            donationAmounts,
            showingPromoCodeForm: false
          };
        }

        onSubmitForm(event) {
          event.preventDefault();
          const data = this.getFormData();
          return (typeof this.props.onSubmit === 'function' ? this.props.onSubmit(data) : undefined);
        }

        onCancel(event) {
          event.preventDefault();
          return (typeof this.props.onCancel === 'function' ? this.props.onCancel() : undefined);
        }

        // Return form data
        getFormData() {
          const donationByTicketClassId = ticketClassDonationById(this.props.ticket_class_groups);
          const donation_amounts = {};
          for (const ticketClassId in this.state.donationAmounts) {
            if (donationByTicketClassId[ticketClassId]) {
              donation_amounts[ticketClassId] = this.state.donationAmounts[ticketClassId];
            }
          }
          return {
            event_instance_id: this.state.selectedDate,
            ticket_quantities: this.state.selectedQuantities,
            donation_amounts
          };
        }

        isValid() {
          const selected_quantities = this.state.selectedQuantities;

          for (const item of Array.from(this.props.ticket_class_groups)) {
            const ticket_classes = item[1];
            for (const ticket_class of Array.from(ticket_classes)) {
              const error = this.props.ticket_errors != null ? this.props.ticket_errors[ticket_class.id] : undefined;
              const donation_amount = this.state.donationAmounts[ticket_class.id];
              const selected_quantity = selected_quantities[ticket_class.id] || 0;

              // Indicate error on price in real time
              if (ticket_class.donation && (selected_quantity > 0)) {
                if ((ticket_class.min_price > 0) && (ticket_class.max_price > 0) && ((donation_amount < ticket_class.min_price) || (donation_amount > ticket_class.max_price))) {
                  return false;
                } else if ((ticket_class.min_price === 0) && (ticket_class.max_price > 0) && (donation_amount > ticket_class.max_price)) {
                  return false;
                } else if ((ticket_class.max_price === 0) && (ticket_class.min_price > 0) && (donation_amount < ticket_class.min_price)) {
                  return false;
                }
              }
            }
          }
          return true;
        }

        render() {
          const have_selections = _.reduce(_.values(this.state.selectedQuantities), (memo, num) => memo + num) > 0;

          if (!this.state.haveInstances) {
            return <div className="widget-content">
              <form className="form_box form-sidebar">
                {!this.state.haveInstances && <p className="error_marker" role="alert">Registration is no longer available for this event</p>}

                <div className="action_button">
                  <a href="#" className="cancel_link em-link" onClick={this.onCancel}>Cancel</a>
                </div>
              </form>
            </div>;
          }
            return <div className="widget-content">
              <form className="form_box form-sidebar">
                {this.props.reservation_ends_at && <ReservationTimer now={this.props.now}
                                  reservationEnds={this.props.reservation_ends_at}
                                  browserTimeOffset={this.props.browser_time_offset} />}

                <FormInputGroup className="select_date">

                    {this.renderInstanceSelector()}

                </FormInputGroup>

                {this.renderTicketGroups()}

                {this.renderPromoCodeForm()}

                {this.props.error && <p className="error_marker" role="alert">There was an error processing your request. Please try again</p>}

                <div className="action_button">
                  <a href="#" className="cancel_link em-link" onClick={this.onCancel}>Cancel</a>
                  <input type="submit"
                        className="em-button em-primary"
                        disabled={!have_selections || !this.isValid() || this.props.loading}
                        onClick={this.onSubmitForm}
                        value={this.props.loading ? "Processing..." : "Continue"} />

                </div>
              </form>
            </div>;

        }

        renderPromoCodeForm() {
          return <PromoCodeForm activePromoCode={this.props.active_promo_code}
                          promoCodeError={this.props.promo_code_error}
                          promoCode={this.props.promo_code}
                          loading={this.props.loading}
                          onApplyPromoCode={this.props.onApplyPromoCode}
                          onRemovePromoCode={this.props.onRemovePromoCode} />;
        }

        onInstanceChange(event) {
          return this.setState(immutable.set(this.state, 'selectedDate', event.target.value));
        }

        // Format an instance hash as a date and time.
        //
        // The +instance+ hash should just have starts_at, ends_at, start_time, and end_time properties.
        _formatInstanceDate(instance) {
          const start_date = parseLocalDate(instance.starts_at, !instance.start_time);
          const end_date = parseLocalDate(instance.ends_at, !instance.start_time);

          return formatTime(start_date, end_date, 'detailed', { dateOnly: !instance.start_time });
        }

        // Format the date range of all instances (specifically for conference events)
        _formatInstanceRange(instances) {
          const start_date = parseLocalDate(instances[0].starts_at, true);
          const end_date = parseLocalDate(instances[instances.length - 1].starts_at, true);

          return formatTime(start_date, end_date, 'detailed', { dateOnly: true });
        }

        renderInstanceSelector() {
          if (this.props.kind === 'conference') {
            return this._formatInstanceRange(this.props.instances);
          }
            if (this.props.instances.length === -1) {
              // Just render the instance date
              return this._formatInstanceDate(this.props.instances[0]);
            }
              const options = (Array.from(this.props.instances).map((instance) => <option key={instance.id} value={instance.id}>{this._formatInstanceDate(instance)}</option>));

              //;// Render the dropdown to choose the current date
              return <div className="em-select-floating">
                  <label htmlFor="instance_select_date">Select date</label>
                  <select id="instance_select_date" value={this.state.selectedDate} onChange={this.onInstanceChange}>
                    {options}
                  </select>
                  <i className="fas fa-sort-down"></i>
                </div>;


        }

        // Callback when changing the quantity of a ticket class
        onQuantityChange(ticket_class_id, quantity) {
          return this.setState(immutable.set(this.state, ['selectedQuantities', ticket_class_id], Number(quantity)));
        }

        // Callback to handle a donation ticket price change
        //
        // Setting price to a non-zero value also sets quantity to 1
        onItemPriceChange(ticket_class_id, amount) {
          if (!ticketClassDonationById(this.props.ticket_class_groups)[ticket_class_id]) {
            return;
          }
          let new_quantity;
          if (amount > 0) {
            new_quantity = 1;
          } else {
            new_quantity = 0;
          }

          return this.setState(immutable(this.state).
            set(['donationAmounts', ticket_class_id], amount).
            set(['selectedQuantities', ticket_class_id], new_quantity).
            value()
          );
        }


        renderTicketGroups() {
          let item;
          const my = this;
          const selected_quantities = this.state.selectedQuantities;
          const selected_date = this.state.selectedDate;
          const {
            currency
          } = this.props;

          return (() => {
            const result = [];
            for (item of Array.from(this.props.ticket_class_groups)) {
              var header;
              const group = item[0];
              var ticket_classes = item[1];

              if (group) {
                header = <FormRow title={group.name} className="ticket-group-header"/>;
              } else {
                header = null;
              }

              const rows = (() => {
                const result1 = [];
                for (var ticket_class of Array.from(ticket_classes)) {
                  let error = my.props.ticket_errors != null ? my.props.ticket_errors[ticket_class.id] : undefined;
                  const donation_amount = my.state.donationAmounts[ticket_class.id] || __guard__(_.find(my.props.cart.items, item => item.ticket_class_id === ticket_class.id), x => x.price) || null;
                  const selected_quantity = selected_quantities[ticket_class.id] || 0;

                  // Indicate error on price in real time
                  const max_price = ticket_class.max_price === 0 ? Infinity : ticket_class.max_price;
                  if (ticket_class.donation && (selected_quantity > 0) && ((donation_amount < ticket_class.min_price) || (donation_amount > max_price))) {
                    error = 'invalid_price';
                  }

                  result1.push(<TicketClassQuantityRow {...ticket_class}
                                           availability={ticket_class.availability[selected_date]}
                                           selectedQuantity={selected_quantity}
                                           donationAmount={donation_amount}
                                           currency={currency}
                                           onQuantityChange={my.onQuantityChange}
                                           onItemPriceChange={my.onItemPriceChange}
                                           error={error}
                                           key={ticket_class.id} />);
                }
                return result1;
              })();

              result.push(<div key={group ? group.id : 'default'}>
                {header}

                <FormInputGroup className="ticket-group-wrap">
                  {rows}
                </FormInputGroup>
              </div>);
            }
            return result;
          })();
        }
}
function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}
